import {
  logAddGiftRegistryItem,
  logRemoveGiftRegistryItem,
} from 'apis/analytics';
import {
  addRegistryItem,
  removeRegistryItem,
  getActiveRegistry,
} from 'apis/registry';
import { reportError } from 'apis/sentry';

const BASE = 'GIFT_REGISTRY/';
export const ACTIVATION = BASE + 'ACTIVE';
const ADD_EVENT = BASE + 'ADD_TO_GIFT_REGISTRY';
const ADD_EVENT_LOADING = ADD_EVENT + '_INITIATE';
const ADD_EVENT_SUCCESS = ADD_EVENT + '_SUCCESS';
const ADD_EVENT_FAILURE = ADD_EVENT + '_FAILURE';
const REMOVE_EVENT = BASE + 'REMOVE_FROM_GIFT_REGISTRY';
const REMOVE_EVENT_LOADING = REMOVE_EVENT + '_INITIATE';
const REMOVE_EVENT_SUCCESS = REMOVE_EVENT + '_SUCCESS';
const REMOVE_EVENT_FAILURE = REMOVE_EVENT + '_FAILURE';

type AddEventPayload = {
  registryId?: string; // optional, defaults to current active registry
  itemNo: string;
  quantity: string;
  source: string;
};

type RemoveEventPayload = {
  registryId: string;
  itemNo: string;
  source: string;
};

export const publish = window.ikea.pubsub.publish;

window.ikea.pubsub.subscribe<IkeaEvent<AddEventPayload>>(
  ADD_EVENT,
  (payload) => {
    publish(ADD_EVENT_LOADING, { payload });
    addRegistryItem(
      payload.registryId,
      payload.itemNo,
      Number(payload.quantity)
    )
      .then(({ data }) => {
        if (data.addRegistryItems.__typename === 'AddRegistryItemsPayload') {
          publish(ADD_EVENT_SUCCESS, {
            title: data.addRegistryItems.registry.title,
            registryId: data.addRegistryItems.registry.id,
            payload,
          });
        } else {
          publish(ADD_EVENT_FAILURE, {
            payload,
            error: data.addRegistryItems.__typename,
          });
        }
        logAddGiftRegistryItem(payload.source);
      })
      .catch((e) => {
        reportError(e);
        publish(ADD_EVENT_FAILURE, { payload });
      });
  }
);

window.ikea.pubsub.subscribe<IkeaEvent<RemoveEventPayload>>(
  REMOVE_EVENT,
  (payload) => {
    publish(REMOVE_EVENT_LOADING, { payload });

    if (!payload.registryId) {
      getActiveRegistry().then(({ data }) => {
        if (data.activeRegistry.__typename === 'ActiveRegistryPayload') {
          removeItemFromRegistry(
            data.activeRegistry.registry.id,
            payload.itemNo,
            payload.source
          );
        }else {
          publish(REMOVE_EVENT_FAILURE, { payload });
        }
      }).catch((e) => {
        reportError(e);
        publish(REMOVE_EVENT_FAILURE, { payload });
      });;
    } else {
      removeItemFromRegistry(
        payload.registryId,
        payload.itemNo,
        payload.source
      );
    }
  }
);

function removeItemFromRegistry(
  registryId: string,
  itemNo: string,
  source: string
) {
  removeRegistryItem(registryId, itemNo)
    .then(({ data }) => {
      if (
        data.removeRegistryItems.__typename === 'RemoveRegistryItemsPayload'
      ) {
        publish(REMOVE_EVENT_SUCCESS, {
          title: data.removeRegistryItems.registry.title,
          registryId: data.removeRegistryItems.registry.id,
          payload: {source, registryId, itemNo},
        });
      } else {
        publish(REMOVE_EVENT_FAILURE, {
          payload: {source, registryId, itemNo},
          error: data.removeRegistryItems.__typename,
        });
      }
      logRemoveGiftRegistryItem(source);
    })
    .catch((e) => {
      reportError(e);
      publish(REMOVE_EVENT_FAILURE, { payload: {source, registryId, itemNo} });
    });
}

type ActiveEventPayload = {};

export const publishActivation = (payload: ActiveEventPayload = {}) =>
  publish<IkeaEvent<ActiveEventPayload>>(ACTIVATION, payload);
